export default "__VITE_ASSET__CCjkiSbo__"